import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Home,
  },
  {
    path: '/index',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home/home.vue'),
  },
  {
    path: '/After',
    name:'After',
    component: () => import(/* webpackChunkName: "home" */ '../views/After/After.vue'),
  },
  {
    path: '/special',
    name: 'Product',
    component: () => import(/* webpackChunkName: "product" */ '../views/Product/product.vue')
  },
  {
    path: '/img',
    name: 'Img',
    component: () => import(/* webpackChunkName: "serve" */ '../views/Serve/Serve.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News/news.vue'),
  },
  {
    path: '/details',
    name: 'Details',
    component: () => import(/* webpackChunkName: "details" */ '../views/News/details.vue'),
  },

  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "connect" */ '../views/Connect/connect.vue')
  },
  {
    path: '/special',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About/about.vue')
  },
  {
    path: '/productList',
    name: 'ProductList',
    component: () => import(/* webpackChunkName: "product" */ '../views/ProductList/product.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior(){
    return{
      x:0,
      y:0,
    }
  }
})


export default router
